<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div v-if="!error && !disabled" class="modal-header" style="background: #292b33;">
                <h3 :class="alert.text" class="my-0">
                    <i class="fa-fw mr-1" :class="alert.icon"></i> {{ alert.title }}
                </h3>
            </div>
            <div class="modal-body">
                <div v-if="error" class="alert alert-danger">
                    {{ error }}
                </div>
                <div v-else>
                    <div v-if="disabled">
                        {{ 'general.loading' | lang }}
                    </div>
                    <div v-else>
                        <p class="mb-0" v-html="userText"></p>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div>
                    <button :disabled="disabled" type="button" class="btn btn-primary"
                            @click="accept" data-dismiss="modal">{{ 'admin.validateList.accept' | lang }}
                    </button>
                    <button type="button" class="btn btn-secondary" @click="reset"
                            data-dismiss="modal">{{ 'admin.validateList.cancel' | lang }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        user: {
          id: 0,
          name: '',
          email: '',
          channel: '',
          valid: false,
          text: '',
        },
        disabled: true,
        error: '',
      };
    },
    computed: {
      userText() {
        return `<strong title="${this.user.name}"><span class="fab fa-youtube fa-sm mr-1"></span> ${this.user.channel}</strong> (${this.user.email}) ${this.user.text}`;
      },
      alert() {
        return {
          type: this.user.valid ? 'alert-primary' : 'alert-info',
          text: this.user.valid ? 'text-primary' : 'text-info',
          icon: this.user.valid ? 'fas fa-exclamation-circle' : 'fas fa-info-circle ',
          title: Lang.get(this.user.valid ? 'admin.validateUser.notice' : 'admin.validateUser.info'),
        };
      },
    },
    methods: {
      updateUser(user) {
        this.disable();
        if (!user.id || !user.email) {
          this.error = Lang.get('admin.validateList.error.userData');
          return;
        }
        this.user = user;
        this.validateUser();
      },
      validateUser() {
        const url = `/review/users/${this.user.id}/valid/`;
        axios.get(url).then(response => {
          this.user.valid = response.data.valid;
          this.user.text = response.data.text;
          this.enable();
        }).catch(error => {
          this.error = error.toString();
        });
      },
      disable() {
        this.reset();
      },
      enable() {
        this.disabled = false;
      },
      reset() {
        Object.assign(this.$data, this.$options.data());
      },
      accept() {
        document.getElementById(`accept-${this.user.id}`).submit();
      },
    },
  };
</script>
